export default {"src":"/_next/static/media/icono1punto.186477bc.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};